module.exports = "static/assets/f9a0fb45ee35279e05b6f4e637509777.svg";